/**
 * The 6-digit code step — `AuthCodeForm` (@tonnie/ui) with its
 * words: the field's label and the submit are the step's own, the resend is
 * shared.
 */
import { useTranslation } from '@tonnie/locale';
import { AuthCodeForm, type AuthCodeFormProps } from '@tonnie/ui';
import { useMemo } from 'react';

export function CodeStep({
  label,
  submitLabel,
  ...rest
}: Omit<AuthCodeFormProps, 'labels'> & { label: string; submitLabel: string }) {
  const { t } = useTranslation();
  const labels = useMemo(
    () => ({
      code: label,
      submit: submitLabel,
      resend: t('auth.flow.code.resend'),
      resendIn: (seconds: number) => t('auth.flow.code.resendIn', { seconds }),
    }),
    [label, submitLabel, t]
  );
  return <AuthCodeForm labels={labels} {...rest} />;
}
